module.exports = __webpack_public_path__ + "fonts/aveny-tinstagram-medium-webfont.c40ecb68.woff2";